import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import buildUrl from "build-url-ts";
import { useDispatch, useSelector } from "react-redux";


import { fetchIntegrations } from "src/legacy/redux/actions/integrations";
import { authenticateLinkedIn, deactivateLinkedInAccount, fetchLinkedInIntegration, invalidateLinkedInIntegration } from "src/redux/actions/integrations/linkedIn";

import Slider from "src/components/slider";
import BackButton from "src/components/backButton";
import Button from "src/components/button";
import { IntegrationTitle } from "src/legacy/pages/settings/integrations/integrations/integrationsOnboarding/IntegrationTitle";
import { IntegrationSections } from "src/legacy/pages/settings/integrations/integrations/integrationsOnboarding/IntegrationSections";
import SwitchButton from "src/components/switchButton";

import { localizedStrings } from "src/localization";

import styles from './styles.module.scss';

import _ from "lodash";

const LinkedInLogo = '/images/linkedIn.svg';
const PuzzleImg = '/images/puzzle.svg';
const AuthenticationExpiredImg = '/images/authenticationExpired.svg';

const apiUrl = `${process.env.REACT_APP_API_URL}`;

const LinkedInIntegration: React.FC = () => {

    const navigate = useNavigate();
    const dispatch: any = useDispatch();

    // integration walkthrough
    const integration = localizedStrings.constants.integrationsOnboarding.integrations.linkedIn;
    const sections = integration.sections;

    const integrationItem = useSelector((state: any) => _.get(state, "integrations.linkedIn.item", null));
    const isIntegrationLoading = useSelector((state: any) => _.get(state, "integrations.linkedIn.loading", false));
    const isIntegrationFetched  = useSelector((state: any) => _.get(state, "integrations.linkedIn.succeeded", false));
    const isAuthenticating = useSelector((state: any) => _.get(state, "integrations.linkedIn.authentication.loading", false));
    const isIntegrationActive = integrationItem?.state?.code === "ok";
    const isIntegrationExpired = integrationItem?.state?.code === "auth_error";

    const isDeactivating = useSelector((state: any) => _.get(state, "integrations.linkedIn.deactivation.loading", false));
    const isDeactivated = useSelector((state: any) => _.get(state, "integrations.linkedIn.deactivation.succeeded", false));

    const [selectedTab, setSelectedTab] = useState<string>();
    const [isScrollDisabled, setIsScrollDisabled] = useState<boolean>(false);

    const [showIntegrationWalkthrough, setShowIntegrationWalkthrough] = useState<boolean>(false);
    const [showIntegrationStatus, setShowIntegrationStatus] = useState<boolean>(false);
    const [isAuthenticationExpired, setIsAuthenticationExpired] = useState<boolean>(false);
    const [showDeactivateConfirmation, setShowDeactivateConfirmation] = useState<boolean>(false);

    const activatedIntegrations = useSelector((state: any) => _.get(state, "legacyRootReducer.settings.integrations.activated.item", []));

    useEffect(() => {
        if (_.size(activatedIntegrations) === 0) {
            dispatch(fetchIntegrations());
        }

        if(!isIntegrationFetched){
            dispatch(fetchLinkedInIntegration());
        }

    }, [])

    useEffect(() => {
        if (isIntegrationActive) {
            setShowIntegrationStatus(true);
            setShowIntegrationWalkthrough(false);
        }
        else if (isIntegrationExpired) {
            setIsAuthenticationExpired(true);
            setShowIntegrationStatus(true);
        }
        else {
            setShowIntegrationWalkthrough(true);
            setShowIntegrationStatus(false);
        }
    }, [isIntegrationActive, isIntegrationExpired])

    useEffect(() => {
        if (!isDeactivating && isDeactivated) {
            navigate("/settings/integrations");
            dispatch(invalidateLinkedInIntegration());
        }
    }, [isDeactivating, isDeactivated])

    const handleClick = () => {
        if (isIntegrationActive) {
            setShowDeactivateConfirmation(true);
        }
        else {
            handleActivate();
        }
    }

    const handleActivate = () => {
        // Calculate Position

        var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

        var w = 0.8 * width;
        var h = 0.8 * height;

        var left = ((width / 2) - (w / 2)) + dualScreenLeft;
        var top = ((height / 2) - (h / 2)) + dualScreenTop;

        const url = buildUrl(apiUrl, {
            path: "/api/2.0/integrations/linkedin/authorize"
        })

        var newWindow = window.open(url, `Authorize LinkedIn Account`, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        // Puts focus on the newWindow
        if (newWindow?.focus) {
            newWindow.focus();
        }

        //Attaching message event listner

        var eventMethod = "addEventListener";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

        // Listen to message from child window
        eventer(messageEvent, handleAuthenticateEvent, false);
        return false;
    }

    const handleAuthenticateEvent = (e) => {

        //Removing message event listner
        var detachEventMethod = 'removeEventListener';
        var deEventer = window[detachEventMethod];
        var messageEvent = detachEventMethod == "detachEvent" ? "onmessage" : "message";
        if (e?.data?.type == "LINKEDIN_AUTHORIZATION_SUCCESS") {
            var code = e?.data?.payload?.code;
            if (code) {
                dispatch(authenticateLinkedIn({ code }))
            }

            deEventer(messageEvent, handleAuthenticateEvent, false);
        }
    }

    // for integrations walk through 
    const handleScroll = (e) => {
        if (isScrollDisabled) {
            return;
        }
        const integration = localizedStrings.constants.integrationsOnboarding.integrations.gmail;
        const sections = integration.sections;

        const buffer = 25;
        let selectedTabIndex = 0;
        for (let i = 0; i < sections.length; i++) {
            const sectionId = sections[i].id;
            const element = document.getElementById(sectionId);

            if (element) {
                const { top } = element.getBoundingClientRect();
                const position = top;

                if (e.target.scrollTop >= position - buffer) {
                    selectedTabIndex = i;
                }
            }
        }
        setSelectedTab(sections[selectedTabIndex].id);
    };

    const disableScroll = (value) => {
        setIsScrollDisabled(value);
    }


    return (

        <Row className={styles.linkedIn}>
            <Col md={3} className={styles.sideBar}>

                <BackButton
                    className={styles.back}
                    title={"Back"}
                    onClick={() => {
                        navigate("/settings/integrations");
                    }}
                />

                <div className={styles.content}>
                    <img src={LinkedInLogo} />

                    <p>
                        Enable seamless content sharing and engagement tracking between Paperflite and LinkedIn, making it easier to amplify your content reach and measure impact.
                    </p>

                    <Button
                        icon="paperflite-right-arrow"
                        text={isIntegrationActive ? "Deactivate" : isAuthenticationExpired ? "Reauthenticate" : "Activate"}
                        variant="primary"
                        disabled={isIntegrationLoading || isDeactivating || isAuthenticating}
                        className={styles.activate}
                        onClick={handleClick}
                    />

                    {(isIntegrationActive || isIntegrationExpired) && <div className={styles.info}>
                        <p>Learn more:</p>
                        <p className={styles.toggle}>
                            <p>Here is how the integration works </p>
                            <SwitchButton
                                id="integrationOnboarding"
                                label={""}
                                className={styles.switch}
                                checked={showIntegrationWalkthrough}
                                handleCheck={() => {
                                    setShowIntegrationWalkthrough(!showIntegrationWalkthrough)
                                    setShowIntegrationStatus(!showIntegrationStatus);
                                }}
                            />
                        </p>
                    </div>}
                </div>
            </Col>
            <Col
                md={9}
                id="right"
                className={styles.right}
                onScroll={(e) => handleScroll(e)}
            >
                {isIntegrationLoading && <div className={styles.messageContainer}>
                    <div>
                        <p>Loading...</p>
                    </div>
                </div>}

                {isIntegrationActive && !isIntegrationLoading && showIntegrationStatus && <div className={styles.messageContainer}>
                    <div>
                        <img src={PuzzleImg} />
                        <p>LinkedIn Integration is currently active for {_.get(integrationItem, "createdBy.email")}</p>
                    </div>
                </div>}


                {isAuthenticationExpired && !isIntegrationLoading && showIntegrationStatus && <div className={styles.messageContainer}>
                    <div>
                        <img src={AuthenticationExpiredImg} />
                        <p>Your authentication to LinkedIn has expired and needs to be renewed.</p>
                    </div>
                </div>}

                {showIntegrationWalkthrough && <div>
                    <IntegrationTitle title={integration.title} />
                    <IntegrationSections sections={sections} tab={selectedTab} disableScroll={disableScroll} />
                </div>}
            </Col>



            <Slider.Dialog
                width={"380px"}
                show={showDeactivateConfirmation}
                onClose={() => setShowDeactivateConfirmation(false)}
            >

                <Slider.Header
                    title="deactivating..."
                    message="LinkedIn" />

                <Slider.Body>
                    <p>Do you wish to continue</p>
                </Slider.Body>

                <Slider.Actions>


                    <Button
                        variant="primary"
                        className={styles.saveButton}
                        icon="paperflite-right-arrow"
                        text={isDeactivating ? "Deactivating..." : "Deactivate"}
                        disabled={isDeactivating}
                        onClick={() => {
                            dispatch(deactivateLinkedInAccount());
                        }}
                    />
                    <Button
                        variant="secondary"
                        className={styles.cancelButton}
                        onClick={() => {
                            setShowDeactivateConfirmation(false);
                        }}
                        disabled={isDeactivating}
                        text="Cancel"
                    />


                </Slider.Actions>


            </Slider.Dialog>

        </Row>
    )
}

export default LinkedInIntegration; 